import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody, Input, Button } from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Select from "react-select"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import moment from 'moment';

import * as backend from "../../helpers/backend_helper"
import EditableColumn from "./EditableColumn"
import MwSelect from "../../components/Common/MwSelect"
import Toaster from "../../components/Common/Toaster"

const uid = () => "u" + Math.random().toString(36).slice(2, 10) + (Date.now() % 100000).toString(36)
const withUids = (groups: any[]) =>
  (groups || []).map((g: any) => ({
    ...g,
    _uid: g._uid || uid(),
    lists: (g.lists || []).map((l: any) => ({ ...l, _uid: l._uid || uid() })),
  }))

const MonthlyMonitoring = (props: any) => {
  const {
    match: {
      params: { orgId, facId },
    },
  } = props
  const months = moment.monthsShort().map(m => {
    return { label: m, value: m }
  })
  // console.log("monthsmonthsmonths",months);
  
  const [monthly, setMonthly] = useState<any[]>([])
  const [seeded, setSeeded] = useState(false)
  // add group
  function addGroup() {
    setMonthly([...monthly, { name: null, lists: [], _uid: uid() }])
  }

  // remove group
  function removeGroup(idx) {
    const cloneList = [...monthly]
    cloneList.splice(idx, 1)
    setMonthly([...cloneList])
  }

  // Drag: reorder groups, and reorder / move points within or across headers.
  function onDragEnd(result) {
    const { source, destination, type } = result
    if (!destination) return
    if (type === "group") {
      if (source.index === destination.index) return
      const clone = [...monthly]
      const [moved] = clone.splice(source.index, 1)
      clone.splice(destination.index, 0, moved)
      setMonthly(clone)
      return
    }
    const fromG = monthly.findIndex(g => g._uid === source.droppableId)
    const toG = monthly.findIndex(g => g._uid === destination.droppableId)
    if (fromG < 0 || toG < 0) return
    if (fromG === toG && source.index === destination.index) return
    const clone = [...monthly]
    const fromLists = [...clone[fromG].lists]
    const [moved] = fromLists.splice(source.index, 1)
    if (fromG === toG) {
      fromLists.splice(destination.index, 0, moved)
      clone[fromG] = { ...clone[fromG], lists: fromLists }
    } else {
      const toLists = [...clone[toG].lists]
      toLists.splice(destination.index, 0, moved)
      clone[fromG] = { ...clone[fromG], lists: fromLists }
      clone[toG] = { ...clone[toG], lists: toLists }
    }
    setMonthly(clone)
  }

  // add question list
  function addSubList(id) {
    const cloneList = [...monthly]
    cloneList[id].lists = [
      ...cloneList[id].lists,
      { name: null, type: "select", months: months, _uid: uid() },
    ]
    setMonthly([...cloneList])
  }
  // update group value
  function updateGroupValue(e, key, idx) {
    const cloneList = [...monthly]
    cloneList[idx][key] = e
    setMonthly([...cloneList])
  }

  // update sub list
  function updateListValue(e, key, idx, liIndex) {
    const cloneList = [...monthly]
    const list = cloneList[idx].lists[liIndex]
    if (list) {
      list[key] = e
    }
    setMonthly([...cloneList])
  }

  //deleteListValue
  function deleteListValue(idx, liIndex) {
    const cloneList = [...monthly]
    const list = cloneList[idx].lists
    list.splice(liIndex, 1)
    setMonthly([...cloneList])
  }

  // on submit
  async function submit() {
    try {
      await backend.updateFactory(orgId, facId, {
        monthlyMonitoringForm: monthly,
      })
      props.update()
      Toaster.success("Monthly Monitoring Updated Success")
    } catch (e) {
      console.log("monthly monitoring error", e)
      Toaster.error("Monthly Monitoring Updated Failed")
    }
  }

  // Seed local state ONCE so unsaved edits (e.g. after deleting a row) are not
  // wiped by a later props.form re-sync.
  useEffect(() => {
    if (props.form && !seeded) {
      setMonthly(withUids(props.form))
      setSeeded(true)
    }
  }, [props.form, seeded])

  return (
    <React.Fragment>
      <Container fluid>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h4>Monthly Monitoring</h4>
          <button
            onClick={addGroup}
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            New Group
          </button>
        </div>
        <br />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="groups" type="group">
                {gprov => (
                <ul
                  className="list-unstyled"
                  style={{ height: "60vh", overflow: "auto" }}
                  ref={gprov.innerRef}
                  {...gprov.droppableProps}
                >
                  {monthly.map((month, idd) => (
                    <Draggable key={month._uid} draggableId={`group-${month._uid}`} index={idd}>
                    {gp => (
                    <li ref={gp.innerRef} {...gp.draggableProps}>
                      <div
                        className="factory-monitoring-group-list"
                        style={{ textAlign: "start" }}
                      >
                        <Row className="align-items-center">
                          <Col md={1}>
                            <i
                              className="mdi mdi-drag-vertical"
                              title="Drag to reorder group"
                              style={{ cursor: "grab", fontSize: "22px", color: "#1D3A5F" }}
                              {...gp.dragHandleProps}
                            />
                          </Col>
                          <Col md={4}>
                            <EditableColumn
                              value={month.name}
                              update={e => updateGroupValue(e, "name", idd)}
                            />
                          </Col>
                          <Col md={5}>
                            <Input
                              onChange={e =>
                                updateGroupValue(
                                  e.target.value,
                                  "resIdentifier",
                                  idd
                                )
                              }
                              value={
                                month.resIdentifier ? month.resIdentifier : ""
                              }
                              placeholder="Responsiblity Identifier"
                              type="text"
                              name="text"
                            ></Input>
                          </Col>

                          <Col lg={1} md={1}>
                            <button
                              onClick={e => addSubList(idd)}
                              type="button"
                              className="btn btn-primary waves-effect waves-light"
                            >
                              ADD
                            </button>
                          </Col>
                          <Col md={1}>
                            <button
                              onClick={e => removeGroup(idd)}
                              type="button"
                              className="btn btn-danger waves-effect waves-light"
                            >
                              <i className="mdi mdi-trash-can d-block font-size-16"></i>{" "}
                            </button>
                          </Col>
                        </Row>
                      </div>
                      <Droppable droppableId={month._uid} type="point">
                      {(pprov, psnap) => (
                      <ul
                        className="list-unstyled"
                        ref={pprov.innerRef}
                        {...pprov.droppableProps}
                        style={{ minHeight: 12, background: psnap.isDraggingOver ? "#eef7f5" : "transparent", borderRadius: 8 }}
                      >
                        {month.lists.map((sublist, subIndex) => (
                          <Draggable key={sublist._uid} draggableId={`point-${sublist._uid}`} index={subIndex}>
                          {dp => (
                          <li ref={dp.innerRef} {...dp.draggableProps} style={{ padding: "10px", border: '1px solid', margin: '2px', ...dp.draggableProps.style }}>
                            <Row className="align-items-center">
                              <Col lg={1}>
                                <i
                                  className="mdi mdi-drag-vertical"
                                  title="Drag to reorder / move to another header"
                                  style={{ cursor: "grab", fontSize: "20px", color: "#8a97a8" }}
                                  {...dp.dragHandleProps}
                                />
                              </Col>
                              <Col lg={3}>
                                <EditableColumn
                                  value={sublist.name ? sublist.name : ""}
                                  update={e =>
                                    updateListValue(e, "name", idd, subIndex)
                                  }
                                />
                              </Col>
                              <Col lg={3}>
                                <Input
                                  onChange={e =>
                                    updateListValue(
                                      e.target.value,
                                      "date",
                                      idd,
                                      subIndex
                                    )
                                  }
                                  value={sublist.date ? sublist.date : ""}
                                  placeholder="date"
                                  max={31}
                                  type="number"
                                  name="number"
                                ></Input>
                              </Col>
                              <Col lg={4}>
                                <MwSelect
                                  value={sublist.type}
                                  placeholder="Type"
                                  onChange={(val: any) =>
                                    updateListValue(val, "type", idd, subIndex)
                                  }
                                  options={[
                                    { value: "input", label: "Input" },
                                    { value: "select", label: "Select" },
                                  ]}
                                />
                              </Col>
                              <Col lg={1}>
                                <button
                                  onClick={e => deleteListValue(idd, subIndex)}
                                  type="button"
                                  className="btn btn-danger waves-effect waves-light"
                                >
                                  <i className="mdi mdi-trash-can d-block font-size-16"></i>{" "}
                                </button>
                              </Col>
                              <Col lg={4}></Col>
                              <Col lg={5}>
                                <Select
                                  value={sublist.months}
                                  isMulti={true}
                                  onChange={(e) => {
                                    updateListValue(
                                      e,
                                      "months",
                                      idd,
                                      subIndex
                                    )
                                  }}
                                  options={months}
                                  classNamePrefix="select2-selection"
                                />
                              </Col>
                            </Row>
                          </li>
                          )}
                          </Draggable>
                        ))}
                        {pprov.placeholder}
                      </ul>
                      )}
                      </Droppable>
                    </li>
                    )}
                    </Draggable>
                  ))}
                  {gprov.placeholder}
                </ul>
                )}
                </Droppable>
                </DragDropContext>
                {monthly.length > 0 && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button onClick={submit} color="success">
                      Submit
                    </Button>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {}
}

export default withRouter<any, any>(connect<any>(mapStateToProps, {})(MonthlyMonitoring))
